import {
    DTOCardFormField,
} from 'app/types/form.types'

import {
    ServiceCenterFormType,
} from '../serviceCenters.types'

const getWorkScheduleFields = ({
    isLunchBreak,
}: {
    isLunchBreak: boolean,
}): DTOCardFormField<keyof ServiceCenterFormType>[] => {
    return [{
        id: 'operationalDays',
        title: 'OPERATIONAL_DAYS',
        className: 'operationalDays',
        fields: [
            {
                name: 'operationalHours',
                componentName: 'OperationalDays',
                className: 'operationalHours',
                labelKey: ' ',
            },
            {
                name: 'isLunchBreak',
                componentName: 'Checkbox',
                className: 'isLunchBreak',
                labelKey: 'LUNCH_BREAK_NEEDED',
            },
            {
                name: 'breakStartsAt',
                componentName: 'TimePicker',
                disabled: !isLunchBreak,
                required: isLunchBreak,
                labelKey: 'STARTS_AT',
            },
            {
                name: 'breakEndsAt',
                componentName: 'TimePicker',
                disabled: !isLunchBreak,
                required: isLunchBreak,
                labelKey: 'ENDS_AT',
            },
        ],
    }]
}

export default getWorkScheduleFields
